import { Draft } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

function createThreadMessageFailure(draft: Draft<IInterventionData>) {
  draft.createThreadMessage.config.isLoading = false;
}

export default createThreadMessageFailure;
